export default __webpack_public_path__ + "static/media/nv5.5889fe94.PNG";